import { Button, Layout, Modal, Spin } from 'antd'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import UserForm from './UserForm'
import { useForm } from 'antd/es/form/Form'
import { deleteRequest, get, post } from '../../Common/api'
import { Color } from '../../Common/Color'
import UsersTab from './UsersTab'

export default function UsersPage () {
  const [activeUsers, setActiveUsers] = useState([])
  const [deletedUsers, setDeletedUsers] = useState([])
  const [owners, setOwners] = useState()
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = useForm()

  useEffect(() => {
    getUsers()
  }, [])

  const getUsers = async () => {
    setLoading(true)
    await get('admin/users', {}, (res) => {
      setLoading(false)
      setActiveUsers(res.active)
      setDeletedUsers(res.deleted)
    }, () => {
      setLoading(false)
    })
  }

  const postUser = async (params) => {
    setLoading(true)
    await post('admin/users', params, () => {
      setModalVisible(false)
      setLoading(false)
      getUsers()
    }, (errors) => {
      setLoading(false)
      form.setFields(
        Object.keys(errors).map((key) => ({
          name: key,
          errors: errors[key]
        }))
      )
    })
  }

  useEffect(() => {
    getOwners()
  }, [])

  const getOwners = async () => {
    setLoading(true)
    await get('admin/owners', {}, (res) => {
      setLoading(false)
      setOwners(res.owners)
    }, () => {
      setLoading(false)
    })
  }

  const openAddModal = () => {
    form.resetFields()
    setModalVisible(true)
  }

  const onAdd = async (values) => {
    await postUser(values)
  }

  const deleteUserModal = async (user) => {
    Modal.confirm({
      title: `${t('Admin.UsersPage.deletePopupTitle')} "${user.last_name} ${user.first_name}"`,
      width: '600px',
      okText: t('actions.confirm'),
      onOk: () => deleteUser(user)
    })
  }

  const deleteUser = async (user) => {
    await deleteRequest(`admin/users/${user.id}`, {}, (res) => {
      const user = activeUsers.find(i => i.id === res.id)
      setActiveUsers(activeUsers.filter(i => i.id !== res.id))
      setDeletedUsers([...deletedUsers, user])
      setLoading(false)
    }, () => {
      setLoading(false)
    })
  }

  return (
    <Layout>
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}><b>{activeUsers.length + deletedUsers.length}</b> {t('Admin.UsersPage.title')}</div>
          <Button onClick={openAddModal} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<PlusOutlined />} />
        </div>
      </Layout>
      <Spin spinning={loading}>
        <UsersTab
          activeUsers={activeUsers}
          deletedUsers={deletedUsers}
          deleteModal={deleteUserModal}
        />
        {modalVisible && <Modal
          open={modalVisible}
          width="1000px"
          title={t('Admin.UsersPage.addUserTitle')}
          okText={t('actions.validate')}
          onOk={form.submit}
          onCancel={() => setModalVisible(false)}
          confirmLoading={loading}
        >
          <Spin spinning={loading}>
            <UserForm form={form} onFinish={onAdd} owners={owners}/>
          </Spin>
        </Modal>}
      </Spin>
    </Layout>
  )
}
